// Registro mínimo de «hay un cobro abierto» en este dispositivo.
//
// El auto-guardado al salir de la mesa NUNCA debe dispararse con el diálogo
// de cobro abierto (el cobro ya envía lo pendiente y cerraría la mesa). El
// PaymentDialog lo marca al abrirse y lo desmarca al cerrarse. Vive fuera
// del store: no provoca renders y se lee en el momento de decidir.

const open = new Map(); // mesaId → nº de diálogos de cobro abiertos

export function markCobroOpen(mesaId) {
  const k = String(mesaId ?? "");
  open.set(k, (open.get(k) || 0) + 1);
}

export function markCobroClosed(mesaId) {
  const k = String(mesaId ?? "");
  const n = (open.get(k) || 0) - 1;
  if (n > 0) open.set(k, n);
  else open.delete(k);
}

/** ¿Hay algún cobro abierto (de cualquier mesa)? */
export const isAnyCobroOpen = () => open.size > 0;

export function __resetCobroRegistryForTests() {
  open.clear();
}
